// Translations for HolyLand Award landing page
// Languages: Russian (ru), English (en), Hebrew (he)

export const LANGUAGES = [
  { code: "ru", name: "Русский", flag: "🇷🇺", dir: "ltr" },
  { code: "en", name: "English", flag: "🇬🇧", dir: "ltr" },
  { code: "he", name: "עברית", flag: "🇮🇱", dir: "rtl" },
];

export const translations = {
  ru: {
    nav: {
      features: "Возможности",
      official: "Официальный сайт",
      download: "Скачать",
    },
    hero: {
      subtitle:
        "Официальное приложение-компаньон для дипломной программы Израильского клуба радиолюбителей (IARC).",
      badge: "Официальное приложение · программа IARC",
      tagline:
        "Освойте израильский эфир с лучшим компаньоном для программы HolyLand Award. Создано для Activator и Hunter — высокоточный трекинг по сетке ICS, спотинг в реальном времени и удобные ADIF-логи.",
      appstore_kicker: "Скачать в",
      googleplay_kicker: "Установить",
      official_link: "Официальная страница дипломной программы HOLYLAND AWARD",
      stat_squares_label: "Квадраты Израиля",
      stat_squares_value: "503 точки",
      stat_live: "Live на карте",
    },
    features: {
      label: "В приложении",
      title: "Всё, что нужно радиолюбителю",
      gps_title: "Точное GPS-позиционирование",
      gps_text: "Сетка ICS высокой точности для подтверждения активаций",
      progress_title: "Карта 23 округов",
      progress_text: "Интерактивная карта всех административных округов Израиля",
      chat_title: "Спотинг в реальном времени",
      chat_text: "Живая лента активаций и push-уведомления",
      route_title: "Глобальные рейтинги",
      route_text: "Таблицы лидеров и прогресс QSO",
      adif_title: "Экспорт ADIF",
      adif_text: "Готовые ADIF-логи для отправки в IARC",
    },
    gallery: {
      label: "Скриншоты",
      title: "5 экранов одного приложения",
      map_t: "Карта",
      map_d: "GPS check-in по геолокации",
      dashboard_t: "Прогресс",
      dashboard_d: "Activator / Hunter и дипломы A/B/C",
      chat_t: "Чат",
      chat_d: "Сообщения между операторами",
      route_t: "Маршрут",
      route_d: "Планирование по районам",
      profile_t: "Профиль",
      profile_d: "Вход и синхронизация",
    },
    links: {
      label: "Ссылки",
      title: "Дипломная программа",
      official_kicker: "Официальный сайт",
      official_title: "Дипломная программа",
      official_text:
        "Правила, категории и условия получения диплома HolyLand Award. Координация программы IARC.",
    },
    download: {
      label: "Скачать",
      title_prefix: "Установите",
      subtitle: "Доступно для iOS и Android. Единая база операторов.",
      tag_quality: "Премиум-качество",
      tag_no_ads: "Без рекламы",
      tag_official: "Официально",
    },
    footer: {
      tagline:
        "Радиолюбительская дипломная программа Израиля. Мобильное приложение и единая база данных активаций.",
      resources: "Ресурсы",
      legal: "Правовая информация",
      privacy: "Политика конфиденциальности",
      terms: "Условия использования",
      support: "Связаться с поддержкой",
      official_link: "Официальная страница диплома",
      download_link: "Скачать приложение",
      rights:
        "© 2026 Michael Shwartz. Все права защищены. HolyLand Award — товарный знак IARC.",
    },
    app: {
      back: "На сайт",
      tab_map: "КАРТА",
      tab_chat: "ЧАТ",
      tab_progress: "ПРОГРЕСС",
      tab_route: "МАРШРУТ",
      tab_profile: "ПРОФИЛЬ",
      all_districts: "ВСЕ РАЙОНЫ",
      checkin: "CHECK-IN",
      login_hint: "Войдите, чтобы фиксировать активации и сохранять прогресс.",
      // Chat
      chat_locked_title: "Войдите для общения",
      chat_locked_text: "Чат доступен только зарегистрированным операторам",
      chat_go_login: "Перейти к входу",
      chat_input_ph: "Сообщение…",
      chat_subtitle: "Общий канал операторов",
      // Dashboard
      progress_subtitle_local: "Локальный режим",
      stat_squares: "Квадратов",
      stat_districts: "Сработано районов",
      stat_unique: "Уникальных SQUARE",
      diploma_categories: "Категории диплома",
      in_progress: "В РАБОТЕ",
      cat_a_title: "Категория A · Внутри Израиля",
      cat_a_desc: "≥150 квадратов из ≥18 районов",
      cat_b_title: "Категория B · IARU R1",
      cat_b_desc: "≥100 квадратов из ≥13 районов",
      cat_c_title: "Категория C · IARU R2/R3",
      cat_c_desc: "≥50 квадратов из ≥13 районов",
      // Route
      route_subtitle: "Планирование активаций по районам Израиля",
      route_card_title: "Соберите свой маршрут",
      route_card_text: "Выберите районы, которые хотите активировать",
      route_districts_label: "Районы Израиля",
      route_active_squares: "активных квадратов",
      // Profile
      profile_hint:
        "Войдите, чтобы синхронизировать журнал между устройствами. Или продолжайте без входа — данные сохранятся локально.",
      lang_label: "ЯЗЫК",
      google_signin: "ВОЙТИ ЧЕРЕЗ GOOGLE",
      or: "ИЛИ",
      tab_login: "ВХОД",
      tab_register: "РЕГИСТРАЦИЯ",
      submit_login: "ВОЙТИ",
      submit_register: "ЗАРЕГИСТРИРОВАТЬСЯ",
      legal_label: "ПРАВОВЫЕ ДОКУМЕНТЫ",
      privacy: "Политика конфиденциальности",
      terms: "Условия использования",
      support: "Связаться с поддержкой",
    },
  },
  en: {
    nav: {
      features: "Features",
      official: "Official site",
      download: "Download",
    },
    hero: {
      subtitle:
        "The official companion app for the Israel Amateur Radio Club (IARC) diploma program.",
      badge: "Official companion · IARC program",
      tagline:
        "Master the Israeli radio airwaves with the ultimate companion for the Holyland Award program. Designed for Activators and Hunters, providing high-precision ICS grid tracking, real-time spotting, and seamless ADIF logs.",
      appstore_kicker: "Download on the",
      googleplay_kicker: "Get it on",
      official_link: "Official diploma program page",
      stat_squares_label: "Israel squares",
      stat_squares_value: "503 points",
      stat_live: "Live on the map",
    },
    features: {
      label: "Inside the app",
      title: "Everything an operator needs",
      gps_title: "Precise GPS Locating",
      gps_text: "High-precision ICS grid tracking system",
      progress_title: "Interactive Map · 23 Districts",
      progress_text: "Every administrative district of Israel on one map",
      chat_title: "Live Spotting & Notifications",
      chat_text: "Real-time activation feed and push alerts",
      route_title: "Global Leaderboards",
      route_text: "Worldwide rankings and QSO progress",
      adif_title: "ADIF Export",
      adif_text: "One-tap ADIF logs ready for IARC submission",
    },
    gallery: {
      label: "Screenshots",
      title: "5 screens, one app",
      map_t: "Map",
      map_d: "GPS check-in by geolocation",
      dashboard_t: "Progress",
      dashboard_d: "Activator / Hunter and A/B/C diplomas",
      chat_t: "Chat",
      chat_d: "Messages between operators",
      route_t: "Route",
      route_d: "Plan by district",
      profile_t: "Profile",
      profile_d: "Sign in and sync",
    },
    links: {
      label: "Links",
      title: "Diploma program",
      official_kicker: "Official site",
      official_title: "Diploma program",
      official_text:
        "Rules, categories and conditions for the HolyLand Award diploma. Coordinated by the IARC.",
    },
    download: {
      label: "Download",
      title_prefix: "Install",
      subtitle:
        "Available for iOS and Android. One unified database of operators.",
      tag_quality: "Premium quality",
      tag_no_ads: "Ad-free",
      tag_official: "Official",
    },
    footer: {
      tagline:
        "The amateur radio diploma program of Israel. Mobile app and unified database of activations.",
      resources: "Resources",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms of Use",
      support: "Contact Support",
      official_link: "Official diploma page",
      download_link: "Download the app",
      rights: "© 2026 HolyLand Award. All rights reserved.",
    },
    app: {
      back: "Back to site",
      tab_map: "MAP",
      tab_chat: "CHAT",
      tab_progress: "PROGRESS",
      tab_route: "ROUTE",
      tab_profile: "PROFILE",
      all_districts: "ALL DISTRICTS",
      checkin: "CHECK-IN",
      login_hint: "Sign in to record activations and save your progress.",
      chat_locked_title: "Sign in to chat",
      chat_locked_text: "Chat is available for registered operators only",
      chat_go_login: "Go to sign in",
      chat_input_ph: "Message…",
      chat_subtitle: "Operators' shared channel",
      progress_subtitle_local: "Local mode",
      stat_squares: "Squares",
      stat_districts: "Districts worked",
      stat_unique: "Unique SQUAREs",
      diploma_categories: "Diploma tiers",
      in_progress: "IN PROGRESS",
      cat_a_title: "Class A · Within Israel",
      cat_a_desc: "≥150 squares from ≥18 districts",
      cat_b_title: "Class B · IARU R1",
      cat_b_desc: "≥100 squares from ≥13 districts",
      cat_c_title: "Class C · IARU R2/R3",
      cat_c_desc: "≥50 squares from ≥13 districts",
      route_subtitle: "Plan activations across Israeli districts",
      route_card_title: "Build your route",
      route_card_text: "Pick the districts you want to activate",
      route_districts_label: "Israeli districts",
      route_active_squares: "active squares",
      profile_hint:
        "Sign in to sync your log across devices. Or continue without sign-in — data is stored locally.",
      lang_label: "LANGUAGE",
      google_signin: "SIGN IN WITH GOOGLE",
      or: "OR",
      tab_login: "SIGN IN",
      tab_register: "SIGN UP",
      submit_login: "SIGN IN",
      submit_register: "CREATE ACCOUNT",
      legal_label: "LEGAL",
      privacy: "Privacy Policy",
      terms: "Terms of Use",
      support: "Contact Support",
    },
  },
  he: {
    nav: {
      features: "תכונות",
      official: "אתר רשמי",
      download: "הורדה",
    },
    hero: {
      subtitle:
        "אפליקציית הקומפניון הרשמית לתכנית התעודה של מועדון חובבי הרדיו בישראל (IARC).",
      badge: "קומפניון רשמי · תכנית IARC",
      tagline:
        "שלטו באוויר הישראלי עם הקומפניון המוביל לתכנית HolyLand Award. עוצב לאקטיבייטורים והאנטרס: מעקב מדויק ברשת ICS, ספוטינג בזמן אמת ולוגים בפורמט ADIF.",
      appstore_kicker: "הורד מ-",
      googleplay_kicker: "התקן מ-",
      official_link: "עמוד התכנית הרשמית",
      stat_squares_label: "ריבועי ישראל",
      stat_squares_value: "503 נקודות",
      stat_live: "שידור חי במפה",
    },
    features: {
      label: "באפליקציה",
      title: "כל מה שצריך לאופרטור חובב",
      gps_title: "איכון GPS מדויק",
      gps_text: "מערכת רשת ICS בדיוק גבוה",
      progress_title: "מפה אינטראקטיבית · 23 מחוזות",
      progress_text: "כל המחוזות המנהליים של ישראל במפה אחת",
      chat_title: "ספוטינג חי והתראות",
      chat_text: "פיד הפעלות בזמן אמת והתראות פוש",
      route_title: "טבלאות לידרבורד גלובליות",
      route_text: "דירוגים בינלאומיים והתקדמות QSO",
      adif_title: "ייצוא ADIF",
      adif_text: "ייצוא ADIF להגשה ל-IARC בלחיצה אחת",
    },
    gallery: {
      label: "צילומי מסך",
      title: "5 מסכים — אפליקציה אחת",
      map_t: "מפה",
      map_d: "צ׳ק-אין GPS לפי מיקום",
      dashboard_t: "התקדמות",
      dashboard_d: "Activator / Hunter ותעודות A/B/C",
      chat_t: "צ׳אט",
      chat_d: "הודעות בין אופרטורים",
      route_t: "מסלול",
      route_d: "תכנון לפי מחוז",
      profile_t: "פרופיל",
      profile_d: "כניסה וסנכרון",
    },
    links: {
      label: "קישורים",
      title: "תכנית התעודה",
      official_kicker: "אתר רשמי",
      official_title: "תכנית התעודה",
      official_text:
        "כללים, קטגוריות ותנאי קבלת התעודה HolyLand Award. בתיאום IARC.",
    },
    download: {
      label: "הורדה",
      title_prefix: "התקינו את",
      subtitle: "זמין ל-iOS ו-Android. מסד נתונים מאוחד של אופרטורים.",
      tag_quality: "איכות פרימיום",
      tag_no_ads: "ללא פרסומות",
      tag_official: "רשמי",
    },
    footer: {
      tagline:
        "תכנית התעודה לחובבי הרדיו של ישראל. אפליקציית מובייל ומסד נתונים מאוחד של הפעלות.",
      resources: "משאבים",
      legal: "מידע משפטי",
      privacy: "מדיניות פרטיות",
      terms: "תנאי שימוש",
      support: "פנייה לתמיכה",
      official_link: "עמוד התעודה הרשמי",
      download_link: "הורדת האפליקציה",
      rights: "© 2026 HolyLand Award. כל הזכויות שמורות.",
    },
    app: {
      back: "חזרה לאתר",
      tab_map: "מפה",
      tab_chat: "צ׳אט",
      tab_progress: "התקדמות",
      tab_route: "מסלול",
      tab_profile: "פרופיל",
      all_districts: "כל המחוזות",
      checkin: "צ׳ק-אין",
      login_hint: "התחבר כדי לתעד הפעלות ולשמור התקדמות.",
      chat_locked_title: "התחבר כדי לדבר",
      chat_locked_text: "הצ׳אט זמין לאופרטורים רשומים בלבד",
      chat_go_login: "מעבר לכניסה",
      chat_input_ph: "הודעה…",
      chat_subtitle: "ערוץ משותף לאופרטורים",
      progress_subtitle_local: "מצב מקומי",
      stat_squares: "ריבועים",
      stat_districts: "מחוזות שהופעלו",
      stat_unique: "SQUAREs ייחודיים",
      diploma_categories: "קטגוריות תעודה",
      in_progress: "בעבודה",
      cat_a_title: "קטגוריה A · בתוך ישראל",
      cat_a_desc: "≥150 ריבועים מ-≥18 מחוזות",
      cat_b_title: "קטגוריה B · IARU R1",
      cat_b_desc: "≥100 ריבועים מ-≥13 מחוזות",
      cat_c_title: "קטגוריה C · IARU R2/R3",
      cat_c_desc: "≥50 ריבועים מ-≥13 מחוזות",
      route_subtitle: "תכנון הפעלות לפי מחוזות ישראל",
      route_card_title: "בנה את המסלול שלך",
      route_card_text: "בחר את המחוזות שברצונך להפעיל",
      route_districts_label: "מחוזות ישראל",
      route_active_squares: "ריבועים פעילים",
      profile_hint:
        "התחבר כדי לסנכרן את היומן בין מכשירים. או המשך ללא כניסה — הנתונים יישמרו מקומית.",
      lang_label: "שפה",
      google_signin: "כניסה דרך GOOGLE",
      or: "או",
      tab_login: "כניסה",
      tab_register: "הרשמה",
      submit_login: "כניסה",
      submit_register: "צור חשבון",
      legal_label: "מסמכים משפטיים",
      privacy: "מדיניות פרטיות",
      terms: "תנאי שימוש",
      support: "פנייה לתמיכה",
    },
  },
};

export function getDirForLang(lang) {
  return LANGUAGES.find((l) => l.code === lang)?.dir || "ltr";
}
